import { useLocalStorage } from './use-local-storage.esm.js';
import { usePrefersDarkMode } from './use-prefers-dark-mode.esm.js';

// import { useEffect } from 'react';
function useDarkMode() {
  // Use our useLocalStorage hook to persist state through a page refresh.
  // Read the recipe for this hook to learn more: usehooks.com/useLocalStorage
  var _useLocalStorage = useLocalStorage('dark-mode-enabled'),
      enabledState = _useLocalStorage[0],
      setEnabledState = _useLocalStorage[1]; // See if user has set a browser or OS preference for dark mode.
  // The usePrefersDarkMode hook composes a useMedia hook (see code below).


  var prefersDarkMode = usePrefersDarkMode(); // If enabledState is defined use it, otherwise fallback to prefersDarkMode.
  // This allows user to override OS level setting on our website.

  var enabled = typeof enabledState !== 'undefined' ? enabledState : prefersDarkMode; // TODO: Restore this once we do site-wide dark mode
  // Fire off effect that add/removes dark mode class

  /* useEffect(
    () => {
      const className = 'dark-mode';
      const element = window.document.body;
         if (enabled) {
        element.classList.add(className);
      } else {
        element.classList.remove(className);
      }
    },
    [enabled], // Only re-call effect when value changes
  ); */
  // Return enabled state and setter

  return [enabled, setEnabledState];
}

export { useDarkMode };
//# sourceMappingURL=use-dark-mode.esm.js.map
